import styled from '@emotion/styled';

const S = {};

S.Placeholder = styled.div`
  label: Placeholder;

  background-color: var(--colors-alabaster);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.Placeholder.SvgError = styled.svg`
  label: SvgError;

  width: 3rem;
  height: 3rem;
  fill: var(--colors-silver-chalice);
`;

export default S;
